import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=6edd89d4&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=6edd89d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd89d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6edd89d4')) {
      api.createRecord('6edd89d4', component.options)
    } else {
      api.reload('6edd89d4', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=6edd89d4&scoped=true&", function () {
      api.rerender('6edd89d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MobileViews/ValidateExpenses/Main.vue"
export default component.exports